// extracted by mini-css-extract-plugin
export default {"info":"g6POqU6UUUvJDDUvcDAI","danger":"QEDmwcqqoEGTIsHs_4dZ","fn":"mzj6OEeiTy0UboU_xtJx","placeHolderShimmer":"VIJI0YCGgOS3SLBhaVab"};